export const environment = {
  production: false,
  apiUrl: 'https://api.tokoslamettanggulangin.shop/' 
};